import "./Home.module.css";
import WebsiteHeader from "@/reusable_sections/Header";
import ArtSpaceHero from "./sections/ArtSpaceHero";
import TwoColumnStickyImage from "./sections/TwoColumnStickyImage";
import FlooringCategories from "./sections/FlooringCategories";
import FeaturedGuardianSeries from "./sections/FeaturedGuardianSeries";
import OurAdvantages from "./sections/OurAdvantages";
import ColorMatchingToolCta from "./sections/ColorMatchingToolCta";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <WebsiteHeader />
      <ArtSpaceHero />
      <TwoColumnStickyImage />
      <OurAdvantages />
      <FlooringCategories />
      <FeaturedGuardianSeries />
      <ColorMatchingToolCta />
      <Footer />
    </div>;
}